import { defaults } from 'cachefactory';

export class CacheConfiguration {
    public static configure(): void {
        Object.assign(defaults, {
            maxAge: 1000 * 60 * 60 * 24,
            deleteOnExpire: 'aggressive',
            recycleFreq: 1000 * 60
        });
    }
}
